import {InfiniteData} from '@tanstack/react-query';
import {IPaginatedResult} from '../../../../incase-domain/search';
import {IPresentation} from '../../../../incase-domain/presentation';
import {Option} from '../../../components/common/Select';
import {User} from '../../../../incase-domain/user';

const toPresentationOption = (item: IPresentation): Option => ({
    label: item.name || '',
    value: item._id,
});

export const presentationOptions = (data: InfiniteData<IPaginatedResult<IPresentation>> | undefined): Option[] => {
    return data?.pages.flatMap((page) => page.content.map(toPresentationOption)) ?? [];
};

const toPresenterOption = (item: User): Option => ({
    label: `${item.username} - ${item.email}`,
    value: item._id,
});

export const presenterOptions = (data: InfiniteData<IPaginatedResult<User>> | undefined): Option[] => {
    return data?.pages.flatMap((page) => page.content.map(toPresenterOption)) ?? [];
};
